import {getProgressCollectionPath, type ProgressDb} from '@cp/model';
import {collection, type CollectionReference} from 'firebase/firestore';
import {firebaseFirestore} from '../../config/firebase';

/**
 * Get the progress collection for a user.
 * @param uid - The user id.
 * @returns The progress collection reference.
 */
export default function getProgressCollectionRef(uid: string): CollectionReference<ProgressDb> {
  return collection(firebaseFirestore, getProgressCollectionPath(uid)) as CollectionReference<ProgressDb>;
}
